// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Log } from "./Log";
import { LogFromJSON, LogFromJSONTyped, LogToJSON, LogToJSONTyped } from "./Log";

/**
 *
 * @export
 * @interface PageLog
 */
export interface PageLog {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<Log>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageLog interface.
 */
export function instanceOfPageLog(value: object): value is PageLog {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageLogFromJSON(json: any): PageLog {
  return PageLogFromJSONTyped(json, false);
}

export function PageLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageLog {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(LogFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageLogToJSON(json: any): PageLog {
  return PageLogToJSONTyped(json, false);
}

export function PageLogToJSONTyped(
  value?: PageLog | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(LogToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
